export enum ApplicationStatus {
  Idle,
  FetchingResults,
  DoneFetchingResults,
  FetchSingleResult,
  DoneFetchingSingleResult,
  BuildingResults,
  DoneBuildingResults,
  RunningSimulation,
  DoneSimulation,
  SavingState,
  DoneSavingState,
  OpenComplete,
  CloseComplete,
  ScenariosModified,
  BuildingSummary,
  DoneBuildingSummary,
}
